const initialState = {
    config_academics: [],
    config_payments: [],
    // config_facultyBankAccounts: [],
};
import { getField, updateField } from 'vuex-map-fields';
import ConfigProvider from '../services/config.provider'
const configService = new ConfigProvider()

export const officerConfig = {
    namespaced: true,
    state: initialState,
    actions: {
        async getAcademics({ commit }) {
            const data = await configService.getAcademics();
            commit('set_academics', data);
        },
        async getPayments({ commit }) {
            const data = await configService.getPayments();
            commit('set_payments', data);
        },
        // async getFacultyBankAccounts({ commit }) {
        //     const data = await configService.getFacultyBankAccounts();
        //     commit('set_facultyBankAccounts', data);
        // },
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        set_academics(state, data) { state.config_academics = data },
        set_payments(state, data) { state.config_payments = data },
        // set_facultyBankAccounts(state, data) { state.config_facultyBankAccounts = data },
    },
};